import { BReportLabel, SActivityStatus, SHomeButton, SHomeTitleContainer, SLegenda, SSubtitle, STitleContainer, STitleH3 } from './common/BCommonComponents';
import React, { useContext, useEffect, useState } from 'react';
import AuthContext from './auth/AuthContext';
import { Box, Collapse, Grid, IconButton, Paper, Table, TableBody, TableContainer, TableRow } from '@material-ui/core';
import { FaAt, FaCircle, FaHeadset, FaHospital, FaLaptop, IoIosArrowDropdown, IoIosArrowDropup } from 'react-icons/all';
import { HeadCell, STableCell, STableHead, STableRow } from './common/ScrivaniaTable';
import { toast } from 'react-toastify';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import { useHistory } from 'react-router-dom';
import { ActivityStatus, CanaleAccessoEnum, DatoDTO, PrestazioneDTO, ReportDataDTO, TipoPrestazione, UserDTO, UserRole } from './common/Dtos';
import { HorizontalGridLines, VerticalBarSeries, VerticalGridLines, XAxis, XYPlot, YAxis } from 'react-vis';
import { dateTimeTableFormat, secondsToHms } from './common/DateUtils';
import AggiungiCodiceFiscaleDialog from './AggiungiCodiceFiscaleDialog';
import AggiungiEmailDialog from './AggiungiEmailDialog';
import VerificaEmailDialog from './VerificaEmailDialog';
import { CambioPasswordDialog } from './CambioPasswordDialog';

export function Home() {
	const auth = useContext(AuthContext);
	const [openCambioPassword, setOpenCambioPassword] = useState<boolean>(false);
	const [prestazioniList, setPrestazioniList] = useState<PrestazioneDTO[]>([]);
	const [openDialogCF, setOpenDialogCF] = useState<boolean>(false);
	const [openDialogEmail, setOpenDialogEmail] = useState<boolean>(false);
	const [openDialogVerificaEmail, setOpenDialogVerificaEmail] = useState<boolean>(false);
	const [userDTO, setUserDTO] = useState<UserDTO>({
		id: '',
		login: '',
		email: '',
		firstname: '',
		lastname: '',
		cooperativa: '',
		authorities: [],
		createdBy: '',
		createdDate: '',
		lastModifiedBy: '',
		lastModifiedDate: '',
		telefono: '',
		indirizzo: '',
		activated: true,
		cooperativaName: '',
		codiceFiscale: '',
		unificazioneAsl: ''
	});
	const [report, setReport] = useState<ReportDataDTO>({
		descrizione: '',
		totalePrestazioni: 0,
		totaleContatti: 0,
		mediaPrestazioniContatto: 0,
		tempoMedioFO: 0,
		tempoMedioBO: 0,
		tempoMedioContatto: 0,
		dati: []
	})
	const history = useHistory();
	const canaleLabel = auth.state.canale === CanaleAccessoEnum.CALL_CENTER ? "Call Center"
		: auth.state.canale === CanaleAccessoEnum.FRONTOFFICE ? "FrontOffice"
			: auth.state.canale === CanaleAccessoEnum.MAIL ? "Mail" : "-";

	const headCells: HeadCell[] = [
		{id: 'tipo', numeric: false, disablePadding: false, label: '', sortable: true},
		{id: 'data', numeric: false, disablePadding: true, label: 'DATA', sortable: true},
		{id: 'codice', numeric: false, disablePadding: true, label: 'CODICE PRESTAZIONE', sortable: true},
		{id: 'prestazione', numeric: false, disablePadding: true, label: 'PRESTAZIONE', sortable: true},
		{id: 'note', numeric: false, disablePadding: true, label: 'NOTE ATTIVITA', sortable: true}
	];

	useEffect(() => {
		getHome();
		getReport();
		if (auth.state.roles?.find(r => r === UserRole.SUPERVISOR || r === UserRole.ADMIN || r === UserRole.RESPONSIBLE || r === UserRole.OPERATOR)) {
		// if (auth.state.roles && auth.state.roles.indexOf(UserRole.REPORT) < 0) {
			getBackofficeInCorso();
		}
		checkCampiObbligatoriUtente();
	}, []);

	const checkCampiObbligatoriUtente = () => {
		checkCodiceFiscale(); //alla chiusura si controlla la presenza dell'indirizzo email
	}

	const getHome = () => {
		auth.state.axiosInstance?.get('/api/prestazione/home', {params: {page: 0, size: 5, sort: ''}})
			.then(res => {
				setPrestazioniList(res.data);
			})
			.catch(error => {
				toast.error('🛑 Errore durante il recupero delle Prestazioni!');
				console.log(error);
			})
	};

	const getReport = () => {
		auth.state.axiosInstance?.get('/api/report/recap_giornaliero_utente/puntoServizio/' + auth.state.puntoServizioLogged?.id)
			.then(res => {
				setReport(res.data)
			})
			.catch(error => {
				toast.error('🛑 Errore durante il recupero del Report giornaliero!');
				console.log(error);
			});
	}

	const getBackofficeInCorso = () => {
		auth.state.axiosInstance?.get('/api/prestazione/numero_mie_prestazioni_in_corso/' + auth.state.puntoServizioLogged?.id)
			.then(res => {
				auth.dispatch({
					type: 'UPDATE_BACKOFFICE_IN_CORSO', payload:
						{
							backofficeInCorso: res.data
						}
				})
			})
			.catch(error => {
				toast.error('🛑 Errore durante il recupero delle Prestazioni!');
				console.log(error);
			});
	}

	const checkCodiceFiscale = () => {
		if (auth.state.roles?.find(r => r === UserRole.OPERATOR)
			|| auth.state.roles?.find(r => r === UserRole.RESPONSIBLE)
			|| auth.state.roles?.find(r => r === UserRole.SUPERVISOR)) {
			// OPN DIALOG
			auth.state.axiosInstance?.get('/api/accounts/' + auth.state.id)
				.then(res => {
					setUserDTO(res.data);
					if (res.data.codiceFiscale === null || res.data.codiceFiscale === '') {
						setOpenDialogCF(true);
					} else {
						checkEmail();
					}
				})
				.catch(error => {
					toast.error('🛑 Errore durante il recupero dell\'Operatore!');
					console.log(error);
				});
		} else {
			checkEmail();
		}
	}

	const checkVerificaEmail = () => {
		if (!auth.state.checkVerificaEmail) {
			auth.state.axiosInstance?.get('/api/accounts/' + auth.state.id)
				.then(res => {
					setUserDTO(res.data);
					setOpenDialogVerificaEmail(true);
				})
				.catch(error => {
					toast.error('🛑 Errore durante il recupero dell\'Operatore!');
					console.log(error);
				});
		} else {
			checkIsExpiredPassword();
		}
	}

	const openEditEmail = () => {
		auth.state.axiosInstance?.get('/api/accounts/' + auth.state.id)
			.then(res => {
				setUserDTO(res.data);
				setOpenDialogEmail(true);
			})
			.catch(error => {
				toast.error('🛑 Errore durante il recupero dell\'Operatore!');
				console.log(error);
			});
	}

	const checkEmail = () => {
		if (!auth.state.checkEmail) {
			openEditEmail();
		} else {
			checkVerificaEmail();
		}
	}

	const handleDialogCambioPasswordClose = (newPassword?: string) => {
		setOpenCambioPassword(false);
		if (newPassword) {
			const encodedPsw = btoa(newPassword);
			auth.state.axiosInstance?.post('/api/accounts/change-user-password', {id: auth.state.id, newPassword: encodedPsw})
				.then(res => {
					toast.success("Password Modificata Correttamente!");
					auth.dispatch({
						type: 'UPDATE_PSW_EXP', payload:
							{
								pswExpirationDate: res.data
							}
					})
				})
				.catch(error => {
					toast.error('🛑 Errore durante la modifica della password');
					console.log(error);
					setOpenCambioPassword(true);
				});
		}
	}

	const handleCloseDialogVerificaEmail = (ex: string) => {
		console.log(ex);
		setOpenDialogVerificaEmail(false);
		if (ex === 'edit') {
			openEditEmail();
		} else if (ex === 'confirm') {
			auth.state.axiosInstance?.post('/api/accounts/confirm-email', userDTO.id)
				.then(res => {
					auth.state.axiosInstance?.post('/api/auth/logout')
						.then(res => {
							history.push("/invio-email-verifica");
							toast.success("Disconnessione avvenuta correttamente.")
						})
						.catch(error => {
							toast.error('🛑 Errore durante la disconnessione!');
							console.log(error);
						})
						.finally(() => {
								auth.dispatch({type: 'LOGOUT'})
							}
						)
				})
				.catch(error => {
					toast.error("🛑 Errore durante l'invio dell'email di verifica");
					console.log(error);
				});
		}
	}

	const handleCloseDialogEmail = (userDTO: UserDTO | undefined) => {
		setOpenDialogEmail(false);
		if (userDTO) {
			auth.state.axiosInstance?.post('/api/accounts/save-and-confirm-email',
				{
					userId: userDTO.id,
					email: userDTO.email
				})
				.then(res => {
					auth.state.checkEmail = true;
					auth.state.axiosInstance?.post('/api/auth/logout')
						.then(res => {
							history.push("/invio-email-verifica");
							toast.success("Disconnessione avvenuta correttamente.")
						})
						.catch(error => {
							toast.error('🛑 Errore durante la disconnessione!');
							console.log(error);
						})
						.finally(() => {
								auth.dispatch({type: 'LOGOUT'})
							}
						)


					// toast.success('Email salvata con successo!');
					// setUserDTO(res.data);
					// checkVerificaEmail();
				})
				.catch(error => {
					toast.error("🛑 Errore durante il salvataggio dell'email");
					console.log(error)
				});
		}
	}

	const handleCloseDialogCF = (userDTO: UserDTO | undefined) => {
		setOpenDialogCF(false);
		if (userDTO) {
			auth.state.axiosInstance?.put('/api/accounts/update/' + userDTO.id,
				{
					id: userDTO.id,
					login: userDTO.login,
					email: userDTO.email,
					firstname: userDTO.firstname,
					lastname: userDTO.lastname,
					cooperativa: userDTO.cooperativa,
					authorities: userDTO.authorities,
					createdBy: userDTO.createdBy,
					createdDate: userDTO.createdDate,
					lastModifiedBy: userDTO.lastModifiedBy,
					lastModifiedDate: userDTO.lastModifiedDate,
					telefono: userDTO.telefono,
					indirizzo: userDTO.indirizzo,
					prestazioniPreferitePuntoList: [],
					cooperativaName: userDTO.cooperativaName,
					codiceFiscale: userDTO.codiceFiscale
				})
				.then(res => {
					toast.success('Codice Fiscale salvato con successo!');
					setUserDTO(res.data);
					checkEmail();
				})
				.catch(error => {
					toast.error('🛑 Errore durante il salvataggio del Codice Fiscale');
					console.log(error)
				});
		}

	}

	const goToContatto = (tipo: string) => {
		if (tipo.toUpperCase() === TipoPrestazione.BACKOFFICE) {
			history.push("/backoffice");
		} else {
			auth.state.axiosInstance?.post('/api/contatto/insert', {
				tipoContatto: tipo.toUpperCase(),
				puntoServizioId: auth.state.puntoServizioLogged?.id,
				cooperativaId: auth.state.cooperativa,
				operatore: auth.state.login
			})
				.then(res => {
					history.push("/contatto/" + tipo + "/" + res.data.id);

				})
				.catch(error => {
					toast.error('🛑 Errore durante il login');
					console.log(error)
				});
		}
	}

	const checkIsExpiredPassword = () => {
		if (auth.state.pswExpirationDate) {
			const passwordDate = new Date(auth.state.pswExpirationDate);
			const dateNow = new Date();
			if (passwordDate < dateNow) {
				toast.error('🛑 Password scaduta, inserire nuova password.');
				setOpenCambioPassword(true);
			}
		} else {
			toast.error('🛑 Password scaduta, inserire nuova password.');
			setOpenCambioPassword(true);
		}
	}

	const getDatiFO = (datiList: DatoDTO[]): any[] => {
		let ret: any[] = [];

		datiList.forEach(d => {
			const newDato = {x: d.label, y: d.numFO};
			ret.push(newDato);
		})

		return ret;
	}

	const getDatiBO = (datiList: DatoDTO[]): any[] => {
		let ret: any[] = [];

		datiList.forEach(d => {
			const newDato = {x: d.label, y: d.numBO};
			ret.push(newDato);
		})

		return ret;
	}

	function Row(props: { row: PrestazioneDTO, labelid: string }) {
		const {row, labelid} = props;
		const [open, setOpen] = React.useState(false);

		return (
			<React.Fragment>
				<STableRow
					hover
					tabIndex={-1}
					key={row.id}
				>
					<STableCell style={{width: 150, borderBottom: 'none'}} component="th" id={labelid} padding="default">
						{
							row.type === 'BACKOFFICE' ? <FaLaptop className="color-secondary" size={30}/> : <FaHospital className="color-secondary" size={30}/>
						}

						<IconButton className="float-right color-primary" aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
							{open ? <IoIosArrowDropup size={20}/> : <IoIosArrowDropdown size={20}/>}
						</IconButton>
					</STableCell>
					{/*<STableCell style={{borderBottom:"none"}} padding="none" color="primary">{new Intl.DateTimeFormat('it-IT').format(row.startDate)}</STableCell>*/}
					<STableCell style={{borderBottom: "none"}} padding="none" color="primary">{dateTimeTableFormat(row.startDate)}</STableCell>
					<STableCell style={{borderBottom: "none"}} padding="none">{row.codice}</STableCell>
					<STableCell style={{borderBottom: "none"}} padding="none">{row.name}</STableCell>
					<STableCell style={{borderBottom: "none"}} padding="none">{row.note}</STableCell>
				</STableRow>
				<TableRow className="bg-white">
					<TableCell style={{paddingBottom: 0, paddingTop: 0, paddingLeft: 100, paddingRight: 0}} colSpan={6}>
						<Collapse in={open} timeout="auto" unmountOnExit>
							<Box className="mt-3">
								<Table size="small" aria-label="purchases">
									<TableHead>
										<TableRow>
											<STableHead bgcolor="secondary">DESCRIZIONE</STableHead>
											<STableHead bgcolor="secondary">STATO ATTIVITA'</STableHead>
											<STableHead bgcolor="secondary" align="right">NOTE</STableHead>
										</TableRow>
									</TableHead>
									<TableBody>
										{row.subTask.map((subTaskRow) => {
												const subStatus = subTaskRow.status === ActivityStatus.OK ? "Esito Ok"
													: subTaskRow.status === ActivityStatus.WAIT ? "In Attesa"
														: subTaskRow.status === ActivityStatus.KO ? "Esito Ko" : "Indefinito";

												return (<STableRow key={subTaskRow.id}>
													<STableCell component="th" scope="row">{subTaskRow.description}</STableCell>
													<STableCell>
														<SActivityStatus status={subTaskRow.status}>{subStatus}</SActivityStatus>
													</STableCell>
													<STableCell align="right">{subTaskRow.nota}</STableCell>
												</STableRow>)
											}
										)}
									</TableBody>
								</Table>
							</Box>
						</Collapse>
					</TableCell>
				</TableRow>
			</React.Fragment>
		)
	}

	return (
		<div>
			<SHomeTitleContainer>
				<STitleH3>Benvenuto {auth.state.prettyName}</STitleH3>
				<SSubtitle>stai lavorando al <b>{auth.state.puntoServizioLogged?.name}</b> e il tuo Canale di Accesso predefinito è <b>{canaleLabel}</b></SSubtitle>
			</SHomeTitleContainer>
			{auth.state.roles && auth.state.roles.indexOf(UserRole.REPORT) == -1 &&
				<Grid container spacing={10}>
					<Grid item xs={3}>
						<SHomeButton onClick={() => goToContatto("frontoffice")}
												 variant="contained"
												 disabled={auth.state.puntoServizioLogged?.puntoServizioConfig}>
							<Grid item xs={4}>
								<FaHospital size={30}/>
							</Grid>
							<Grid item xs={8}>
								Nuovo contatto frontoffice
							</Grid>
						</SHomeButton>
					</Grid>
					<Grid item xs={3}>
						<SHomeButton onClick={() => goToContatto("callcenter")}
												 variant="contained"
												 disabled={auth.state.puntoServizioLogged?.puntoServizioConfig}>
							<Grid item xs={4}>
								<FaHeadset size={30}/>
							</Grid>
							<Grid item xs={8}>
								Nuovo contatto call center
							</Grid>
						</SHomeButton>
					</Grid>
					<Grid item xs={3}>
						<SHomeButton onClick={() => goToContatto(TipoPrestazione.BACKOFFICE)}
												 variant="contained"
												 disabled={auth.state.puntoServizioLogged?.puntoServizioConfig}>
							<Grid item xs={4}>
								<FaLaptop size={30}/>
							</Grid>
							<Grid item xs={8}>
								Nuovo contatto backoffice
							</Grid>
						</SHomeButton>
					</Grid>
					<Grid item xs={3}>
						<SHomeButton onClick={() => goToContatto("mail")}
												 variant="contained"
												 disabled={auth.state.puntoServizioLogged?.puntoServizioConfig}>
							<Grid item xs={4}>
								<FaAt size={30}/>
							</Grid>
							<Grid item xs={8}>
								Nuovo contatto mail
							</Grid>
						</SHomeButton>
					</Grid>
				</Grid>
			}
			{auth.state.puntoServizioLogged?.puntoServizioConfig && auth.state.roles && auth.state.roles.indexOf(UserRole.REPORT) == -1 &&
				<p className="text-danger text-center mt-2">Per poter inserire prestazioni &egrave; necessario effettuare la login in un punto di servizio attivo.</p>
			}
			<Grid container spacing={0} className="w-100 px-2 pt-5">
				<Grid item xs={8} className="px-2 d-flex justify-content-center">
					<Box p={0}>
						<BReportLabel>Prestazioni della giornata</BReportLabel>
						<XYPlot margin={{bottom: 70}} xType="ordinal" width={750} height={300}>
							<VerticalGridLines/>
							<HorizontalGridLines/>
							<XAxis/>
							<YAxis/>
							<VerticalBarSeries
								data={getDatiFO(report.dati)}
								barWidth={0.5}
								fill={'#D8E4F8'}
								stroke={'#D8E4F8'}
							/>
							<VerticalBarSeries
								data={getDatiBO(report.dati)}
								barWidth={0.5}
								fill={'#002C74'}
								stroke={'#002C74'}
							/>
						</XYPlot>
					</Box>
				</Grid>
				<Grid item xs={4} className="px-4 pt-5">
					<Box p={0}>
						<p className="d-flex align-items-center"><FaCircle className="color-blue-secondary" size={20}/><span className="ml-2">Prestazioni FrontOffice</span></p>
						<p className="d-flex align-items-center"><FaCircle className="color-primary" size={20}/><span className="ml-2">Prestazioni BackOffice</span></p>
						<p className=""><b>Totale prestazioni eseguite:</b> {report.totalePrestazioni}</p>
						<p className=""><b>Media prestazioni FrontOffice per singolo contatto:</b> {report.mediaPrestazioniContatto}</p>
						<p className=""><b>Tempo medio per prestazione FrontOffice:</b> {secondsToHms(report.tempoMedioFO)}</p>
						<p className=""><b>Tempo medio per prestazione BackOffice:</b> {secondsToHms(report.tempoMedioBO)}</p>
					</Box>
				</Grid>
			</Grid>
			<STitleContainer>
				<STitleH3>Ultime 3 prestazioni effettuate</STitleH3>
			</STitleContainer>
			<Grid container spacing={1} className="w-100">
				<Grid item xs={12} className="d-flex justify-content-end mb-3">
					<SLegenda className="color-primary">LEGENDA: </SLegenda>
					<FaLaptop className="color-secondary mx-1" size={20}/> Attivit&agrave; di BackOffice
					<FaHospital className="color-secondary mx-1" size={20}/> Attivit&agrave; di FrontOffice
				</Grid>
			</Grid>
			<Paper>
				<TableContainer>
					<Table
						aria-labelledby="tableTitle"
						size={'medium'}
						aria-label="enhanced table"
					>
						<TableHead>
							<TableRow>
								{headCells.map((headCell) => (
									<STableHead
										key={headCell.id}
										align={headCell.numeric ? 'right' : 'left'}
										padding={headCell.disablePadding ? 'none' : 'default'}
									>
										{headCell.label}
									</STableHead>
								))}
							</TableRow>
						</TableHead>
						<TableBody>
							{prestazioniList
								.map((row, index) => {
									const labelId = `enhanced-table-checkbox-${index}`;
									return (
										<Row key={row.id} row={row} labelid={labelId}/>
									);
								})}
						</TableBody>
					</Table>
				</TableContainer>
			</Paper>
			<AggiungiCodiceFiscaleDialog open={openDialogCF} onClose={handleCloseDialogCF} userDTO={userDTO}/>
			<AggiungiEmailDialog open={openDialogEmail} onClose={handleCloseDialogEmail} userDTO={userDTO}/>
			<VerificaEmailDialog open={openDialogVerificaEmail} onClose={handleCloseDialogVerificaEmail} userDTO={userDTO}/>
			<CambioPasswordDialog open={openCambioPassword} onClose={handleDialogCambioPasswordClose} canClose={false} userId={auth.state.id}/>
		</div>
	)
}
